import React from "react";
import StatusBadge from "./StatusBadge";
import { formatNumber, formatPercent } from "../utils/formatters";

function formatCell(columnKey, value) {
  if (columnKey === "plan" || columnKey === "simulated" || columnKey === "realized" || columnKey === "gap") {
    return formatNumber(value, 1);
  }
  if (columnKey === "attendancePct") {
    return formatPercent(value, 1);
  }
  return value ?? "-";
}

export default function ResultsTable({
  rows,
  visibleColumns,
  allColumns,
  groupBy,
  onToggleColumn,
}) {
  const columns = (allColumns || []).filter((column) => visibleColumns.includes(column.key));

  return (
    <section className="swb-panel">
      <div className="swb-panel__head">
        <h3>Plano x Simulado x Realizado</h3>
        <span className="swb-subtle">Agrupamento: {groupBy}</span>
      </div>

      <div className="swb-columns-picker" role="group" aria-label="Colunas visíveis">
        {(allColumns || []).map((column) => (
          <label key={column.key} className="swb-chip">
            <input
              type="checkbox"
              checked={visibleColumns.includes(column.key)}
              onChange={() => onToggleColumn(column.key)}
            />
            <span>{column.label}</span>
          </label>
        ))}
      </div>

      <div className="swb-table-wrap">
        <table className="swb-table">
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.key}>{column.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length ? (
              rows.map((row) => (
                <tr key={row.id}>
                  {columns.map((column) => (
                    <td key={`${row.id}_${column.key}`}>
                      {column.key === "status" ? (
                        <StatusBadge status={row.status} />
                      ) : (
                        formatCell(column.key, row[column.key])
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={Math.max(1, columns.length)} className="swb-empty-cell">
                  Nenhum resultado para os filtros selecionados.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
